module.exports = __webpack_public_path__ + "static/img/logo.30129621.svg";